/*
 * Duallys Only custom PayTomorrow MPE
 * Uses PayTomorrow's API methods instead of mpeInit so the product page keeps
 * its own controlled, fixed-size financing line and avoids the oversized
 * animated widget output.
 */
(function () {
  'use strict';

  var PUBLIC_ID = 'ae55664a8d4e91044b22413d500f476b';
  var STORE_NAME = 'Duallys Only';
  var CHANNEL = 'ECOMMERCE';
  var MAX_TERM = 24;
  var MIN_AMOUNT = 500;
  var MAX_AMOUNT = 10000;
  var iframeAdded = false;
  var retryCount = 0;

  var options = {
    debugMode: false,
    useSandbox: false,
    enableMoreInfoLink: true,
    logoColor: 'original',
    maxAmount: MAX_AMOUNT,
    maxTerm: MAX_TERM,
    minAmount: MIN_AMOUNT,
    storeDisplayName: STORE_NAME,
    publicId: PUBLIC_ID,
    displayPrimeOffers: false,
    primeApr: 0,
    primeHasZero: false,
    prefixString: 'As low as',
    postfixString: 'Learn More',
    priceDelimiter: ''
  };

  function formatCurrency(value) {
    var amount = Number(value);
    if (!isFinite(amount) || amount <= 0) return '';

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: amount % 1 === 0 ? 0 : 2
    }).format(amount);
  }

  function getAmount(slot) {
    var cents = Number(slot.getAttribute('data-amount-cents'));
    if (!isFinite(cents) || cents <= 0) return 0;
    return cents / 100;
  }

  function fallbackUrl() {
    return 'https://consumer.paytomorrow.com/pre-approval/learn-more?organizationName=' +
      encodeURIComponent(STORE_NAME) +
      '&publicId=' + encodeURIComponent(PUBLIC_ID) +
      '&channel=' + encodeURIComponent(CHANNEL) +
      '&preapproval=false';
  }

  function ensureIframe() {
    if (iframeAdded) return true;
    if (!window.PayTomorrow || typeof window.PayTomorrow.addPayTomorrowIframe !== 'function') return false;

    try {
      window.PayTomorrow.addPayTomorrowIframe(STORE_NAME, PUBLIC_ID, CHANNEL);
      iframeAdded = true;
      return true;
    } catch (error) {
      return false;
    }
  }

  function estimateMonthly(amount, term) {
    if (!window.PayTomorrow || typeof window.PayTomorrow.getMonthlyPayment !== 'function') return null;

    try {
      var monthly = window.PayTomorrow.getMonthlyPayment(amount, term, options);
      monthly = Number(monthly);
      return isFinite(monthly) && monthly > 0 ? monthly : null;
    } catch (error) {
      return null;
    }
  }

  function renderSlot(slot) {
    if (!slot) return;

    var amount = getAmount(slot);
    var copy = slot.querySelector('.duallys-paytomorrow-copy');
    var button = slot.querySelector('[data-paytomorrow-learn-more]');
    var term = Number(slot.getAttribute('data-max-term')) || MAX_TERM;

    if (!copy || !button) return;

    if (!amount) {
      slot.hidden = true;
      return;
    }

    slot.hidden = false;
    ensureIframe();

    var monthly = null;
    if (amount >= MIN_AMOUNT && amount <= MAX_AMOUNT) {
      monthly = estimateMonthly(amount, term);
    }
    if (monthly) {
      copy.innerHTML = '<span class="duallys-paytomorrow-amount">' + formatCurrency(monthly) + '/mo</span> with <span class="duallys-paytomorrow-logo" aria-label="PayTomorrow">PayTomorrow</span>';
    } else {
      copy.innerHTML = 'Pay over time with <span class="duallys-paytomorrow-logo" aria-label="PayTomorrow">PayTomorrow</span>';
    }
  }

  function renderAll() {
    var slots = document.querySelectorAll('[data-paytomorrow-mpe]');
    for (var i = 0; i < slots.length; i += 1) {
      renderSlot(slots[i]);
    }
  }

  function openPayTomorrow() {
    if (ensureIframe() && window.PayTomorrow && typeof window.PayTomorrow.openMpeIframe === 'function') {
      try {
        window.PayTomorrow.openMpeIframe();
        return;
      } catch (error) {}
    }

    window.open(fallbackUrl(), 'duallysPayTomorrow', 'noopener,noreferrer,width=980,height=760');
  }

  function scheduleRetry() {
    if (retryCount > 30) return;
    retryCount += 1;
    window.setTimeout(function () {
      renderAll();
      if (!window.PayTomorrow || typeof window.PayTomorrow.getMonthlyPayment !== 'function') {
        scheduleRetry();
      }
    }, 250);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest && event.target.closest('[data-paytomorrow-learn-more]');
    if (!trigger) return;
    event.preventDefault();
    openPayTomorrow();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      renderAll();
      scheduleRetry();
    });
  } else {
    renderAll();
    scheduleRetry();
  }

  window.addEventListener('load', renderAll);
  document.addEventListener('variant:change', function () {
    window.setTimeout(renderAll, 100);
    window.setTimeout(renderAll, 450);
  });
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(renderAll, 100);
    scheduleRetry();
  });

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      var mutation = mutations[i];
      if (!mutation.addedNodes || !mutation.addedNodes.length) continue;
      for (var n = 0; n < mutation.addedNodes.length; n += 1) {
        var node = mutation.addedNodes[n];
        if (node.nodeType !== 1) continue;
        if ((node.matches && node.matches('[data-paytomorrow-mpe]')) || (node.querySelector && node.querySelector('[data-paytomorrow-mpe]'))) {
          window.setTimeout(renderAll, 60);
          return;
        }
      }
    }
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
